import React from 'react';
import { FadeIn, SectionDivider, BadgeLabel } from '../ui';
import { Check, X, BookOpen, Moon, Sparkles, Shield, Eye, Smartphone, Globe, Star, Gift } from 'lucide-react';
export const ProductSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-331">
      {/* BLOQUE 6: PRESENTACIÓN DEL PRODUCTO */}
      <section className="py-20 px-4 relative" data-id="element-332">
        <div className="max-w-6xl mx-auto" data-id="element-333">
          <FadeIn data-id="element-334">
            <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-335">
              <div className="w-full lg:w-1/2 relative" data-id="element-336">
                <div className="absolute inset-0 bg-gold/20 blur-[100px] rounded-full" data-id="element-337"></div>
                <img src="https://cdn.magicpatterns.com/uploads/mLt6zmWg4iG7hGKFnK4MFL/bloque_del_dolor.png" alt="Manual Amarre Ancestral" className="relative z-10 w-full max-w-md mx-auto rounded-lg shadow-[0_0_50px_rgba(200,168,75,0.2)] border border-gold/20" data-id="element-338" />
              </div>

              <div className="w-full lg:w-1/2 space-y-6" data-id="element-339">
                <BadgeLabel data-id="element-340">
                  Manual Digital · PDF · Entrega Inmediata
                </BadgeLabel>

                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-none" data-id="element-341">
                  AMARRE ANCESTRAL <br data-id="element-342" />
                  <span className="text-3xl md:text-4xl text-gold font-serif italic mt-2 block" data-id="element-343">
                    DE 3 NOCHES
                  </span>
                </h2>

                <p className="text-xl text-burgundy font-bold uppercase tracking-wider" data-id="element-344">
                  Lo que los "brujos" no quieren que sepas
                </p>

                <div className="text-lg text-text-secondary space-y-4" data-id="element-345">
                  <p data-id="element-346">
                    El manual en 20 módulos que contiene el ritual completo paso
                    a paso para recuperar al amor de tu vida en solo 3 noches,
                    usando elementos cotidianos que ya tienes en casa.
                  </p>
                  <p className="text-white font-medium" data-id="element-347">
                    Sin intermediarios. Sin gastos extras. Sin depender de nadie
                    más.
                  </p>
                  <p data-id="element-348">
                    Este no es un libro de autoayuda con palabras bonitas. Es el
                    ritual exacto, los decretos específicos y las instrucciones
                    precisas que los falsos maestros adaptaron, corrompieron y
                    comenzaron a vender a precios absurdos haciéndote creer que
                    ellos eran el ingrediente secreto.
                  </p>
                  <p className="text-2xl font-serif text-gold italic pt-4" data-id="element-349">
                    El ingrediente secreto siempre fuiste tú.
                  </p>
                </div>

                {/* Bonus highlight */}
                <div className="mt-6 flex items-start gap-3 p-4 rounded-lg bg-gold/10 border border-gold/30" data-id="element-350">
                  <div className="text-gold shrink-0 mt-0.5" data-id="element-351">
                    <Gift size={22} data-id="element-352" />
                  </div>
                  <div data-id="element-353">
                    <p className="text-gold font-bold text-sm uppercase tracking-widest mb-1" data-id="element-354">
                      + 2 Bonos Gratis incluidos hoy
                    </p>
                    <p className="text-text-secondary text-sm" data-id="element-355">
                      Kit de Preparación + Guía de Calma Post-Proceso. Valor
                      adicional de $114 USD — incluidos sin costo extra.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-356" />

      {/* BLOQUE 7: TABLA COMPARATIVA */}
      <section className="py-12 px-4" data-id="element-357">
        <div className="max-w-5xl mx-auto" data-id="element-358">
          <FadeIn data-id="element-359">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-360">
              ¿Por qué funciona cuando los otros fallaron?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0" data-id="element-361">
              {/* Brujo Card */}
              <div className="bg-mystic-800/50 border border-white/10 p-8 rounded-xl md:rounded-r-none md:border-r-0" data-id="element-362">
                <h3 className="text-2xl font-serif text-text-secondary text-center mb-8 pb-4 border-b border-white/10" data-id="element-363">
                  BRUJO "MAESTRO"
                </h3>
                <ul className="space-y-6 text-text-secondary" data-id="element-364">
                  <li className="flex flex-col gap-1" data-id="element-365">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-366">
                      Costo
                    </span>
                    <span className="flex items-center gap-2" data-id="element-367">
                      <X size={16} className="text-burgundy" data-id="element-368" /> $300 – $1,000
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-369">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-370">
                      Quién hace el ritual
                    </span>
                    <span className="flex items-center gap-2" data-id="element-371">
                      <X size={16} className="text-burgundy" data-id="element-372" /> Un extraño sin
                      conexión energética
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-373">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-374">
                      Garantía
                    </span>
                    <span className="flex items-center gap-2" data-id="element-375">
                      <X size={16} className="text-burgundy" data-id="element-376" /> Ninguna
                      ("depende la energía")
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-377">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-378">
                      Tiempo de acceso
                    </span>
                    <span className="flex items-center gap-2" data-id="element-379">
                      <X size={16} className="text-burgundy" data-id="element-380" /> "En unos días"
                      (quizás nunca)
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-381">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-382">
                      Si no funciona
                    </span>
                    <span className="flex items-center gap-2" data-id="element-383">
                      <X size={16} className="text-burgundy" data-id="element-384" /> Te cobran más
                      para el "refuerzo"
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-385">
                    <span className="text-sm uppercase tracking-wider opacity-60" data-id="element-386">
                      Ingrediente secreto
                    </span>
                    <span className="flex items-center gap-2" data-id="element-387">
                      <X size={16} className="text-burgundy" data-id="element-388" /> Él/ella (el
                      impostor)
                    </span>
                  </li>
                </ul>
              </div>

              {/* Amarre Card */}
              <div className="bg-mystic-800 border-2 border-gold p-8 rounded-xl relative shadow-[0_0_30px_rgba(200,168,75,0.15)] md:-ml-2 z-10" data-id="element-389">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-mystic-900 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-390">
                  Tu Elección
                </div>
                <h3 className="text-2xl font-serif text-gold text-center mb-8 pb-4 border-b border-gold/20" data-id="element-391">
                  AMARRE ANCESTRAL
                </h3>
                <ul className="space-y-6 text-white font-medium" data-id="element-392">
                  <li className="flex flex-col gap-1" data-id="element-393">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-394">
                      Costo
                    </span>
                    <span className="flex items-center gap-2" data-id="element-395">
                      <Check size={18} className="text-gold" data-id="element-396" /> Solo $12 USD
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-397">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-398">
                      Quién hace el ritual
                    </span>
                    <span className="flex items-center gap-2" data-id="element-399">
                      <Check size={18} className="text-gold" data-id="element-400" /> Tú — el único
                      con el hilo real
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-401">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-402">
                      Garantía
                    </span>
                    <span className="flex items-center gap-2" data-id="element-403">
                      <Check size={18} className="text-gold" data-id="element-404" /> 7 días o te
                      devuelvo todo
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-405">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-406">
                      Tiempo de acceso
                    </span>
                    <span className="flex items-center gap-2" data-id="element-407">
                      <Check size={18} className="text-gold" data-id="element-408" /> En segundos,
                      empiezas esta noche
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-409">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-410">
                      Si no funciona
                    </span>
                    <span className="flex items-center gap-2" data-id="element-411">
                      <Check size={18} className="text-gold" data-id="element-412" /> Garantía de
                      devolución total
                    </span>
                  </li>
                  <li className="flex flex-col gap-1" data-id="element-413">
                    <span className="text-sm uppercase tracking-wider text-gold/80" data-id="element-414">
                      Ingrediente secreto
                    </span>
                    <span className="flex items-center gap-2" data-id="element-415">
                      <Check size={18} className="text-gold" data-id="element-416" /> Tú mismo/a —
                      siempre lo fue
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-417" />

      {/* BLOQUE 8: LO QUE RECIBES */}
      <section className="py-12 px-4" data-id="element-418">
        <div className="max-w-4xl mx-auto" data-id="element-419">
          <FadeIn data-id="element-420">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-421">
              Todo lo que incluye tu manual hoy
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-422">
              {[{
              title: 'El Ritual Completo de las 3 Noches',
              desc: 'Instrucciones exactas noche por noche, sin margen de error ni pasos confusos.',
              icon: <Moon size={24} data-id="element-423" />
            }, {
              title: 'Los Decretos Ancestrales',
              desc: 'Las palabras precisas que activan la conexión energética — cada sílaba importa.',
              icon: <BookOpen size={24} data-id="element-424" />
            }, {
              title: 'Guía de Elementos de Poder',
              desc: 'Cómo usar lo que ya tienes en tu cocina como catalizadores ancestrales reales.',
              icon: <Sparkles size={24} data-id="element-425" />
            }, {
              title: 'Protocolo de Limpieza Previa',
              desc: 'Elimina bloqueos de envidias y terceros antes de comenzar las 3 noches.',
              icon: <Shield size={24} data-id="element-426" />
            }, {
              title: 'Técnica del Espejo',
              desc: 'Proyecta tu intención directamente en el subconsciente de la persona amada.',
              icon: <Eye size={24} data-id="element-427" />
            }, {
              title: 'La Regla del Silencio de Oro',
              desc: 'El paso que el 90% omite y que hace que todo lo demás falle. Aquí lo sabrás.',
              icon: <Check size={24} data-id="element-428" />
            }, {
              title: 'Diccionario de Señales',
              desc: 'Cómo interpretar los mensajes del universo en las 72 horas siguientes al ritual.',
              icon: <Star size={24} data-id="element-429" />
            }, {
              title: 'Hoja de Seguimiento de Resultados',
              desc: 'Rastrea las señales de retorno día a día para saber que está funcionando.',
              icon: <Check size={24} data-id="element-430" />
            }, {
              title: 'El Escudo Contra Envidias',
              desc: 'Para que una vez que regrese, ningún tercero pueda volver a separarlos.',
              icon: <Shield size={24} data-id="element-431" />
            }, {
              title: '20 Módulos de Conocimiento',
              desc: 'Desde el diagnóstico de interferencias externas hasta la magia digital — todo lo que necesitas saber en un solo lugar.',
              icon: <BookOpen size={24} data-id="element-432" />
            }].map((item, idx) => <div key={idx} className="glass-panel p-6 rounded-xl flex gap-4 items-start" data-id="element-433">
                  <div className="text-gold mt-1 bg-gold/10 p-2 rounded-lg" data-id="element-434">
                    {item.icon}
                  </div>
                  <div data-id="element-435">
                    <h4 className="text-white font-bold text-lg mb-1" data-id="element-436">
                      {item.title}
                    </h4>
                    <p className="text-text-secondary text-sm leading-relaxed" data-id="element-437">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* NEW VISUAL SECTION: LAS 3 NOCHES */}
      <section className="py-20 px-4 bg-mystic-800/30 border-y border-gold/10 mt-12" data-id="element-438">
        <div className="max-w-6xl mx-auto" data-id="element-439">
          <FadeIn data-id="element-440">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gold mb-12 italic" data-id="element-441">
              El Viaje de las 3 Noches
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-442">
              <div className="group relative overflow-hidden rounded-xl border border-gold/20 aspect-[4/5]" data-id="element-443">
                <img src="https://cdn.magicpatterns.com/uploads/nDMAVupurnYXJ7iq84HHSK/noche_1.png" alt="Noche 1" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-444" />
                <div className="absolute inset-0 bg-gradient-to-t from-mystic-900 via-mystic-900/40 to-transparent flex flex-col justify-end p-6" data-id="element-445">
                  <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2" data-id="element-446">
                    Noche 1
                  </span>
                  <h3 className="text-2xl font-serif text-white" data-id="element-447">
                    La Invocación
                  </h3>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-xl border border-gold/20 aspect-[4/5] md:translate-y-8" data-id="element-448">
                <img src="https://cdn.magicpatterns.com/uploads/x6XSoj5i6PG8aNmtkipPat/noche_2.png" alt="Noche 2" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-449" />
                <div className="absolute inset-0 bg-gradient-to-t from-mystic-900 via-mystic-900/40 to-transparent flex flex-col justify-end p-6" data-id="element-450">
                  <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2" data-id="element-451">
                    Noche 2
                  </span>
                  <h3 className="text-2xl font-serif text-white" data-id="element-452">El Vínculo</h3>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-xl border border-gold/20 aspect-[4/5]" data-id="element-453">
                <img src="https://cdn.magicpatterns.com/uploads/dLfacVqsQaEGvqvFGBEqza/noche_3.png" alt="Noche 3" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-454" />
                <div className="absolute inset-0 bg-gradient-to-t from-mystic-900 via-mystic-900/40 to-transparent flex flex-col justify-end p-6" data-id="element-455">
                  <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2" data-id="element-456">
                    Noche 3
                  </span>
                  <h3 className="text-2xl font-serif text-white" data-id="element-457">El Retorno</h3>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BLOQUE 9: CÓMO FUNCIONA */}
      <section className="py-20 px-4" data-id="element-458">
        <div className="max-w-5xl mx-auto" data-id="element-459">
          <FadeIn data-id="element-460">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-461">
              Así de simple es empezar esta misma noche
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-462">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gold/20 z-0" data-id="element-463"></div>

              {[{
              step: 'PASO 1',
              title: 'COMPRAS',
              icon: <Shield size={32} data-id="element-464" />,
              desc: 'Haces clic en el botón. El proceso tarda menos de 2 minutos y es completamente seguro y encriptado.'
            }, {
              step: 'PASO 2',
              title: 'DESCARGAS',
              icon: <Smartphone size={32} data-id="element-465" />,
              desc: 'Acceso inmediato al manual en PDF desde cualquier dispositivo. Sin esperar correos ni links que no llegan.'
            }, {
              step: 'PASO 3',
              title: 'EMPIEZAS ESTA NOCHE',
              icon: <Moon size={32} data-id="element-466" />,
              desc: 'La primera noche del ritual comienza a las 9:00 PM. Esta misma noche, si quieres.'
            }].map((item, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-467">
                  <div className="w-24 h-24 rounded-full bg-mystic-800 border-2 border-gold flex items-center justify-center text-gold mb-6 shadow-[0_0_20px_rgba(200,168,75,0.2)]" data-id="element-468">
                    {item.icon}
                  </div>
                  <div className="text-gold font-bold tracking-widest text-sm mb-2" data-id="element-469">
                    {item.step}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4" data-id="element-470">
                    {item.title}
                  </h3>
                  <p className="text-text-secondary" data-id="element-471">{item.desc}</p>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </section>
    </div>;
};